import { KroneSalzamtleiter, PferdeeisenbahnTransportgespann, Kaiserschiff } from "../../Utils/GlbLoaderArtefakte.jsx";
import ExperienceModelViewer from "../ExperienceModelViewer.jsx";

export default function ArtefaktBundlesKHofGmunden({ currentMuseumId }) {
  const { kroneSalzamtleiter } = KroneSalzamtleiter();
  const { pferdeeisenbahnTransportgespann } = PferdeeisenbahnTransportgespann();
  const { kaiserschiff } = Kaiserschiff();

  const artefactArray = [kroneSalzamtleiter, pferdeeisenbahnTransportgespann, kaiserschiff];

  return <ExperienceModelViewer modelArray={artefactArray} currentMuseumId={currentMuseumId} />;
}
